"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Input_1 = require("./Input");
exports.default = Input_1.default;
//# sourceMappingURL=index.js.map